export default __webpack_public_path__ + "bfb20074566b50b23310b2969349f73a.jpg";